import React, { Component } from 'react';
import { debounce } from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ReportsActions } from 'store/ducks/reports';
import { Creators as StoresActions/* , Selectors as StoresSelectors */ } from 'store/ducks/stores';

import { Form } from 'components';

class Filters extends Component {
  constructor(props) {
    super(props);

    const { getStoresRequest } = props;

    this.handleSearch = debounce(getStoresRequest, 300);
  }

  componentDidMount() {
    const { getStoresRequest } = this.props;

    getStoresRequest();
  }


  render() {
    const { data, onChange, onClean } = this.props;

    return (
      <Form className="row form-filters">

        <Form.Field className="col-md-5">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_start}
              onChange={value => onChange('date_start', value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-5">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={data.date_end}
              onChange={value => onChange('date_end', value)}
              minDate={data.date_start}
              disabled={data.date_start === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapstate = state => ({
  // reports: state.reports,
  // stores: {
  //   ...state.stores,
  //   data: StoresSelectors.options(state.stores.data),
  // },
});

const mapActions = dispatch => bindActionCreators({ ...ReportsActions, ...StoresActions }, dispatch);

export default connect(
  mapstate,
  mapActions,
)(Filters);
